
(function(template){
define('vue!app/views/vue/basicComponents/popup',['Vue'],function(Vue){
    return {
      template: template,
      name: "popup",
      props: ['conflicting_item','showBook'],
      data: function () {
        return {
          showModal: false
        }
      },
      methods: {
        show: function () {
          this.showModal = true
        },
        hid: function () {
          this.showModal = false
        },
        handleClick: function(){
         
          this.$emit('handle-Continue-Click')
          this.hid()
        }
      },

    }
})
})('<div v-if="showModal"> <!-- Button to trigger modal --> <a style="display:none" href="#package_item_conflict_popup" role="button" class="btn" data-toggle="modal">Launch demo modal</a> <!-- Modal --> <div id="package_item_conflict_popup" class="modal show " :class="showModal? \'fade in\': null" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"> <div class="modal-header" > <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button> --> <h3 id="myModalLabel"><slot name="header"> header</slot></h3> </div> <div class="modal-body"> <slot name="body"></slot> </div> <div class="modal-footer"> <button class="btn close-btn " @click="hid">{{localization.general.close}}</button> <!-- <slot name="booking"></slot> --> <button v-if="showBook" @click="handleClick()" class="btn btn-primary">Book anyway</button> </div> </div> </div>');
